module.exports = __webpack_public_path__ + "img/icono-inhabilitado.445efe52.svg";